import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { AlertTriangle } from 'lucide-react';
import { useCompany } from '@/hooks/useCompany';
import { useCompanyContractStatus } from '@/hooks/useCompanyContractStatus';
import { CompanyContractAcceptanceForm } from '@/components/legal/CompanyContractAcceptanceForm';

export function CompanyContractBanner() {
  const { company, isCompanyManager } = useCompany();
  const { data: status } = useCompanyContractStatus(company?.companyId);
  const [open, setOpen] = useState(false);

  if (!company || !isCompanyManager || !status?.needsReacceptance) {
    return null;
  }

  return (
    <>
      <Alert variant="destructive" className="mb-4">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>
          {status.hasAcceptance ? 'Nova versão do Contrato B2B' : 'Contrato B2B pendente'}
        </AlertTitle>
        <AlertDescription className="space-y-2">
          <p>
            {status.hasAcceptance
              ? 'Há uma versão atualizada do Contrato B2B/DPA que precisa ser aceita pelo representante da empresa.'
              : 'Esta empresa ainda não tem registro do aceite do Contrato B2B e DPA. Para manter conformidade LGPD, registre o aceite agora.'}
          </p>
          <div className="flex gap-2 flex-wrap">
            <Button size="sm" variant="default" onClick={() => setOpen(true)}>
              Registrar aceite agora
            </Button>
            <Button size="sm" variant="outline" asChild>
              <Link to="/app/privacy">Ver detalhes em Privacidade</Link>
            </Button>
          </div>
        </AlertDescription>
      </Alert>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Contrato B2B e DPA</DialogTitle>
            <DialogDescription>
              Aceite em nome de <strong>{company.companyName}</strong>.
            </DialogDescription>
          </DialogHeader>
          <CompanyContractAcceptanceForm
            companyId={company.companyId}
            compact
            submitLabel="Confirmar aceite"
            onSuccess={() => setOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
